import { useSelector } from 'react-redux'
import { selectAuthData } from '../store/selectors/authSelectors'

const useAuthUser = () => useSelector(selectAuthData)

export default useAuthUser
